import React from 'react';
import { connect } from 'react-redux';
import { PageBody, PageContent } from '@bit/knotchinc.web-react-components.page';
import FilterSideMenu from '@bit/knotchinc.web-react-components.filter-side-menu';
import ListSync from '@bit/knotchinc.web-react-components.list-sync';
import DateFilter from '@bit/knotchinc.web-react-components.date-filter';
import ContentCard from 'components/Global/Card/ContentCard.jsx';
import ContentFilter from 'components/Global/Filters/ContentFilter/ContentFilter.jsx';
import TagFilter from 'components/Global/Filters/TagFilter/TagFilter.jsx';
import EntityFilter from 'components/Global/Filters/EntityFilter/EntityFilter.jsx';
// import SearchFilter from 'components/Global/Filters/SearchFilter/SearchFilter.jsx';
import ChecklistFilter from 'components/Global/Filters/ChecklistFilter/ChecklistFilter.jsx';
import SelectedFiltersBar from 'components/Global/Filters/SelectedFiltersBar/SelectedFiltersBar.jsx';
import Mixpanel from 'helpers/Mixpanel.js';
import { SET_KEYWORDS_FILTER, SET_BRANDS_FILTER, SET_PUBLISHERS_FILTER, SET_CATEGORIES_FILTER } from 'components/Global/Filters/actions.js';
import { ContentFeedContainer } from '../Home/styled.js';
import { fetchSubscribedKeywords, fetchSubscribedPublishers, fetchSubscribedCategories,
  fetchSubscribedBrands, fetchSubscribedFeed, SET_SUBSCRIBED_FEED_FILTER } from './actions.js';

export class SubscribedFeedView extends React.Component {
  componentDidMount() {
    Mixpanel.track('view Subscribed Library');
  }
  render() {
    const { subscribedContentList, categoriesList, keywordsList, brandsList, publishersList,
      getPublishers, getBrands, getCategories, getKeywords, getFeed } = this.props;
    const currentFilters = subscribedContentList.filters;

    return (
      <PageBody>
        <FilterSideMenu clearAll={() => {}}>
          <DateFilter filterAction={SET_SUBSCRIBED_FEED_FILTER} />
          {/* <SearchFilter filterAction={SET_SUBSCRIBED_FEED_FILTER} /> */}
          <TagFilter
            title="keywords"
            type="keyword_tags"
            filters={keywordsList.filters}
            items={keywordsList}
            fetch={clear => getKeywords(clear)}
            selectedItems={currentFilters.keyword_tags}
            filterAction={SET_SUBSCRIBED_FEED_FILTER}
            listAction={SET_KEYWORDS_FILTER}
          />
          <ChecklistFilter
            type="categories"
            filters={categoriesList.filters}
            items={categoriesList}
            fetch={clear => getCategories(clear)}
            selectedItems={currentFilters.categories}
            filterAction={SET_SUBSCRIBED_FEED_FILTER}
            listAction={SET_CATEGORIES_FILTER}
          />
          <EntityFilter
            title="brands"
            type="brand_ids"
            filters={brandsList.filters}
            items={brandsList}
            fetch={clear => getBrands(clear)}
            selectedItems={currentFilters.brand_ids}
            filterAction={SET_SUBSCRIBED_FEED_FILTER}
            listAction={SET_BRANDS_FILTER}
          />
          <EntityFilter
            title="publishers"
            type="publisher_ids"
            filters={publishersList.filters}
            items={publishersList}
            fetch={clear => getPublishers(clear)}
            selectedItems={currentFilters.publisher_ids}
            filterAction={SET_SUBSCRIBED_FEED_FILTER}
            listAction={SET_PUBLISHERS_FILTER}
          />
          <ContentFilter
            type="content"
            filters={subscribedContentList.filters}
            filterAction={SET_SUBSCRIBED_FEED_FILTER}
          />
        </FilterSideMenu>
        <PageContent>
          <SelectedFiltersBar filters={currentFilters} filterAction={SET_SUBSCRIBED_FEED_FILTER} />
          <ContentFeedContainer>
            <ListSync
              fetch={clear => getFeed(clear)}
              listStore={subscribedContentList}
              loadOnScroll
              actionType={SET_SUBSCRIBED_FEED_FILTER}
              loadingPlaceholders={12}
            >
              <ContentCard />
            </ListSync>
          </ContentFeedContainer>
        </PageContent>
      </PageBody>
    );
  }
}

const mapStateToProps = ({
  PublishersList: { publishersList },
  BrandsList: { brandsList },
  KeywordsList: { keywordsList },
  CategoriesList: { categoriesList },
  Library: { subscribedContentList },
}) => ({ subscribedContentList, publishersList, categoriesList, keywordsList, brandsList });

const mapDispatchToProps = dispatch => ({
  getFeed: clear => dispatch(fetchSubscribedFeed(clear)),
  getKeywords: clear => dispatch(fetchSubscribedKeywords(clear)),
  getCategories: clear => dispatch(fetchSubscribedCategories(clear)),
  getBrands: clear => dispatch(fetchSubscribedBrands(clear)),
  getPublishers: clear => dispatch(fetchSubscribedPublishers(clear)),
});

export default connect(mapStateToProps, mapDispatchToProps)(SubscribedFeedView);
